import { render, staticRenderFns } from "./sys_account.vue?vue&type=template&id=3465c9b5&scoped=true"
import script from "./sys_account.vue?vue&type=script&lang=js"
export * from "./sys_account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3465c9b5",
  null
  
)

export default component.exports